import Icon from '../components/Icon.vue'

Icon.register({
  ankh: {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M296 256H251.4C272.5 222 288 181.6 288 144 288 55.6 230.7 0 160 0S32 55.6 32 144C32 181.6 47.5 222 68.6 256H24C10.8 256 0 266.7 0 280V312C0 325.3 10.8 336 24 336H120V488C120 501.3 130.8 512 144 512H176C189.3 512 200 501.3 200 488V336H296C309.3 336 320 325.3 320 312V280C320 266.7 309.3 256 296 256zM160 80C189.6 80 208 104.5 208 144 208 178.7 180.9 222.1 160 244.9 139.1 222.2 112 178.7 112 144 112 104.5 130.4 80 160 80z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ankh.js
// module id = tQxk
// module chunks = 144